import React from 'react';
import {
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonGrid,
  IonRow,
  IonCol,
  IonButton,
  IonText,
  IonSpinner,
} from '@ionic/react';
import styles from '../../pages/login/LoginReg.module.scss';
import { useTranslation } from 'react-i18next';

interface MainCardProps {
  cardClasses: string;
  cardHeaderClasses: string;
  uiState: {
    loggingIn: boolean;
  };
  authLoading: boolean;
  isDisabled: boolean;
  onLoginClick: () => void;
  onRegisterClick: () => void;
}

export const MainCard: React.FC<MainCardProps> = ({
  cardClasses,
  cardHeaderClasses,
  uiState,
  authLoading,
  isDisabled,
  onLoginClick,
  onRegisterClick
}) => {
  const { t } = useTranslation();
  return (
  <IonCard className={cardClasses}>
    <IonCardHeader className={cardHeaderClasses}>
      <IonCardTitle color="light" className={styles.cardTitle}>{t('components.AuthComponents.MainCard.rSMaidsServiceBooking')}
      </IonCardTitle>
    </IonCardHeader>
    <IonGrid>
      <IonRow>
        <IonCol className={styles.centerCol}>
          <IonButton
            expand="block"
            className={`ion-margin-top ${styles.customButton} ${styles.mainButton}`}
            onClick={onLoginClick}
            disabled={isDisabled}
          >{t('components.AuthComponents.MainCard.login')}
          </IonButton>
        </IonCol>
      </IonRow>
      <IonRow className={styles.registerTextMargin}>
        <IonCol className="ion-text-center">
          <IonText color="medium">{t('components.AuthComponents.MainCard.notAMemberYet')}{' '}
            <span
              className={styles.registerLink}
              onClick={onRegisterClick}
            >{t('components.AuthComponents.MainCard.registerHere')}
            </span>
          </IonText>
        </IonCol>
      </IonRow>
      {(uiState.loggingIn || authLoading) && (
        <IonRow className="ion-justify-content-center ion-padding">
          <IonSpinner name="bubbles" color="primary" />
          {authLoading && <IonText><p>{t('components.AuthComponents.MainCard.processing')}</p></IonText>}
        </IonRow>
      )}
    </IonGrid>
  </IonCard>
);
};
